<template>
  <div class="my-6 min-w-0">
    <BlockRenderer
      :block="{ component: block.component, props: block.props, enabled: true }"
      :builder-preview="preview"
    />
  </div>
</template>

<script setup lang="ts">
import type { BlogBuilderBlock } from '~/types/blog'

defineProps<{
  block: BlogBuilderBlock
  preview?: boolean
}>()
</script>
